import { useContext } from 'react'
import styles from './Signup.module.scss'
import { GlobalNotificationContext } from '../../../Context/GlobalNotification/GlobalNotificationProvider'
import { GlobalLoaderContext } from '../../../Context/GlobalLoader/GlobalLoader'
import { NotificationType } from '../../../Context/GlobalNotification/Types'
import { USER_CREATED_SUCCESSFULLY } from '../../../const/consts'
import { userSignup } from '../../../service/User/api'
import { LoginPageType, LoginPageTypes } from '../LoginPageTypes'
import { RHFSimpleFormBuilder } from '../../../service/FormGenerator/RHFSimpleFormBuilder'
import { formsDefinitions } from '../../../service/FormGenerator/FormDefinitions'
import { SignUpProps } from '../../../service/FormGenerator/FormDefinitions/zodSchema/signUpschema'
import sharedStyles from '../../../sharedStyles.module.scss'

interface Props {
  changeFormHandler: (formType: LoginPageTypes) => void
}

export const Signup = ({ changeFormHandler }: Props): JSX.Element => {
  const showNotification = useContext(GlobalNotificationContext)
  const showLoader = useContext(GlobalLoaderContext)

  const onSubmit = async (credentials: SignUpProps) => {
    showLoader(true)
    try {
      await userSignup(
        {
          name: credentials.name,
          surname: credentials.surname,
          password: credentials.password,
          username: credentials.username.toLocaleLowerCase(),
          email: credentials.email.toLocaleLowerCase()
        },
        credentials.passwordRepeated
      )
      setTimeout((): void => {
        showNotification(NotificationType.INFO, USER_CREATED_SUCCESSFULLY)
        changeFormHandler(LoginPageType.LOGIN)
      }, 2000)
    } catch (err) {
      /* empty */
    }
    showLoader(false)
  }

  return (
    <section>
      <RHFSimpleFormBuilder
        formDefinition={formsDefinitions.signup}
        onSubmit={onSubmit}
      />

      <div className={styles.AdditionalInfoContainer}>
        <p>
          <span>Jeżeli masz już konto, </span>
          <button
            type='button'
            onClick={(): void => changeFormHandler(LoginPageType.LOGIN)}
            className={sharedStyles.ButtonToInternalLink}
          >
            zaloguj się
          </button>
        </p>
      </div>
    </section>
  )
}
